import { Button } from "primereact/button"
import { OverlayPanel } from "primereact/overlaypanel";

const PatientDetailCard = ({ t, selectedPatient, setExerciseDialogVisible, patientDetailOp, visitNote, setEditPatientDialogVisible }: any) => {
    const bmiCalculation = (weight: number, height: number) => {
        if (weight && height) {
            const heightInMeters = height / 100;
            return (weight / (heightInMeters * heightInMeters)).toFixed(2);
        }
        return "---";
    }

    const toggleAddPlan = (e:any) => {
        patientDetailOp?.current?.toggle(e);
        setExerciseDialogVisible(true);
    }

    return (
        <OverlayPanel ref={patientDetailOp} style={{ width: "42rem" }} className="patientDetailOverlayPanel">
            <div className="w-full h-full">
                <div className="w-full pb-4">
                    <div className="flex justify-content-between align-items-center gap-2">
                        <div className="flex justify-content-center align-items-center gap-4">
                            <img src={`${selectedPatient.gender === "Male" ? "/Man.png" : "/Female.png"}`}
                                style={{ borderRadius: "100px", width: "8.375rem", height: "8.375rem" }}
                            />
                            <div className="flex flex-column gap-3">
                                <div>
                                    <p className="m-0 text-lg font-bold" style={{ color: "#2D3967", textWrap: "wrap" }}>{selectedPatient.firstName} {selectedPatient.lastName}</p>
                                </div>
                                <div className='flex flex-row gap-2 '>
                                    <img src="/PhoneIcon.svg" />
                                    <span className='text-sm' style={{ color: "#727A99" }}>{selectedPatient.phoneNumber ? selectedPatient.phoneNumber : "---"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-column justify-content-center align-items-center py-2 gap-1">
                            <Button
                                style={{
                                    fontWeight: "bold",
                                    top: "0.25rem",
                                    right: "0.25rem"
                                }}
                                className="absolute"
                                outlined
                                text
                                rounded
                                onClick={() => setEditPatientDialogVisible(true)}
                                icon={<img src="/editIcon.svg" />}
                            />
                            {(selectedPatient.code) ? (
                                <p className="m-0 text-sm" style={{ color: "#727A99" }}>{t("registerCode")}  <span className="m-0 text-lg font-bold" style={{ color: "#2D3967" }}> {selectedPatient.code}</span></p>
                            ) : (
                                <p className="m-0 text-sm text-center" style={{ color: "#727A99" }}>
                                    <span className="m-0 text-md font-bold" style={{ color: "#2D3967" }}>
                                        {t("noAccessCode")}
                                        <span onClick={toggleAddPlan} className="underline" style={{ cursor: "pointer" }}> {t('addPlan')}.</span>
                                    </span>
                                </p>
                            )}
                            <Button
                                style={{
                                    backgroundColor: "#6383F4",
                                    color: "white",
                                    border: "#E3506B",
                                    height: "2.5rem",
                                    borderRadius: "10px",
                                    width: "12rem",
                                    fontWeight: "bold"
                                }}
                            >
                                <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                    <img src="/SendIcon.svg" />
                                    {t("sendSms")}
                                </span>
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="grid gap-3">
                    <div className="col p-4" style={{ backgroundColor: "#3D4B7F08", borderRadius: "15px" }}>
                        <div className="flex flex-column gap-3">
                            <p className="m-0 text-lg font-bold" style={{ color: "#2D3967" }}>{t("demographicInformation")}</p>
                            <div className="flex gap-3 align-items-center">
                                <img src="/birthDateIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("age")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{selectedPatient.age ? selectedPatient.age : "---"}</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/genderIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("genderWord")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{selectedPatient.gender ? t(`gender.${selectedPatient.gender}`) : "---"}</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/heightIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("height")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{selectedPatient.height ? selectedPatient.height : "---"} cm</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/weightIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("weight")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{selectedPatient.weight ? selectedPatient.weight : "---"} kg</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/bmiIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("bmi")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{bmiCalculation(selectedPatient.weight, selectedPatient.height)} cm</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col p-4" style={{ backgroundColor: "#3D4B7F08", borderRadius: "15px" }}>
                        <div className="flex flex-column gap-3">
                            <p className="m-0 text-lg font-bold" style={{ color: "#2D3967" }}>{t("lastVitals")}</p>
                            <div className="flex gap-3 align-items-center">
                                <img src="/temperatureIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("temperature")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{visitNote?.vitalSigns?.bodyTemperature ? visitNote?.vitalSigns?.bodyTemperature : "---"} °C</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/bloodPressureIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("bloodPressure")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{visitNote?.vitalSigns?.bloodPressure?.systolicBloodPressure ? visitNote?.vitalSigns?.bloodPressure?.systolicBloodPressure : "---"} / {visitNote?.vitalSigns?.bloodPressure?.diastolicBloodPressure ? visitNote?.vitalSigns?.bloodPressure?.diastolicBloodPressure : "---"} mm Hg</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/heartRateIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("heartRate")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{visitNote?.vitalSigns?.pulse ? visitNote?.vitalSigns?.pulse : "---"} bpm</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/respirationRateIcon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("respirationRate")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>{visitNote?.vitalSigns?.respiratoryRate ? visitNote?.vitalSigns?.respiratoryRate : "---"} bpm</p>
                                </div>
                            </div>
                            <div className="flex gap-3 align-items-center">
                                <img src="/spo2Icon.svg" />
                                <div className="flex flex-column align-items-start justify-content-center">
                                    <p className="m-0 text-xs" style={{ color: "#727A99" }}>{t("spo2")}</p>
                                    <p className="m-0 text-sm font-bold" style={{ color: "#2D3967" }}>% {visitNote?.vitalSigns?.saturationSpO2 ? visitNote.vitalSigns?.saturationSpO2 : "---"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </OverlayPanel>
    )

}

export default PatientDetailCard